import { CoordinatePoint, CoordinatePointModel } from './coordinate-point';

export interface ProcedureCoordinatePoint {
    id:number,
    altitude:number,
    coordPoint:CoordinatePointModel,
    procedureCoordPointPk:number,
    procedurecoordpointtype:string,
    sequencenumber:number,
    isCurvePoint:boolean
}

export class ProcedureCoordinatePointModel implements ProcedureCoordinatePoint {
  id:number;
  altitude:number;
  coordPoint:CoordinatePointModel;
  procedureCoordPointPk:number;
  procedurecoordpointtype:string;
  sequencenumber:number;
  isCurvePoint:boolean;
  isDeletedFromMap?: boolean

}
